import { Flex } from '@chakra-ui/react'

import { createWidget } from '../../widgets/widget-utils'

// TODO: this should probably go away.
export const CardHeaderWrapper = ({ ...props }: any) => {
  return (
    <Flex
      spacing="0"
      rounded="lg"
      border="1px"
      borderColor="presets.neutral.20"
      minHeight="112px"
      paddingX="40px"
      alignItems="center"
      justifyContent="space-between"
      overflow="scroll"
      style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
      }}
      sx={{
        '&::-webkit-scrollbar': { display: 'none' },
      }}
      {...props}
    ></Flex>
  )
}

export default createWidget(CardHeaderWrapper, {
  type: 'CardHeaderWrapper',
})
